import { render, staticRenderFns } from "./SignupConfirm.vue?vue&type=template&id=55cb5351&scoped=true&"
import script from "./SignupConfirm.vue?vue&type=script&lang=js&"
export * from "./SignupConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SignupConfirm.vue?vue&type=style&index=0&id=55cb5351&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cb5351",
  null
  
)

export default component.exports